// Template System Types

export interface TemplateCptEntry {
  code: string;
  description: string;
  default_modifiers?: string[];
}

export interface SurgeonTemplate {
  id: string;
  surgeon_id: string;
  template_name: string;
  specialty: string;
  body_region: string | null;
  laterality_required: boolean;
  primary_cpts: TemplateCptEntry[];
  secondary_cpts: TemplateCptEntry[];
  narrative_template: string | null;
  common_addons: TemplateCptEntry[];
  diagnosis_codes: { code: string; description: string }[];
  metadata: Record<string, unknown>;
  version: number;
  is_active: boolean;
  is_demo: boolean;
  created_at: string;
  updated_at: string;
}

export interface SurgeonFacility {
  id: string;
  surgeon_id: string;
  facility_name: string;
  facility_type: string;
  address: string | null;
  phone: string | null;
  is_default: boolean;
  is_active: boolean;
  is_demo: boolean;
}

export interface PreLoadedDoc {
  type: string;
  status: 'verified' | 'pending' | 'rejected';
  uploaded_by?: string;
  uploaded_at?: string;
  extracted_text?: string;
  source_path?: string;
}

export interface ScheduledCase {
  id: string;
  patient_name: string;
  patient_dob: string | null;
  patient_mrn: string | null;
  patient_sex?: string | null;
  clinical_metrics?: Record<string, unknown>;
  surgeon_id: string;
  facility_id: string | null;
  facility_name: string | null;
  scheduled_date: string | null;
  scheduled_procedure: string | null;
  encounter_id: string | null;
  payer_name: string | null;
  plan_name: string | null;
  member_id: string | null;
  status: string;
  is_demo: boolean;
  pre_loaded_docs?: PreLoadedDoc[];
}

// Case-level CPT line item (editable per case)
export interface CaseCptLine {
  code: string;
  description: string;
  modifiers: string[];
  section: 'primary' | 'secondary';
  fromTemplate: boolean;
}

// Template variable context for rendering
export interface TemplateVariableContext {
  PATIENT_NAME: string;
  DOB: string;
  MRN: string;
  CSN: string;
  DATE_OF_SERVICE: string;
  SURGEON_NAME: string;
  FACILITY_NAME: string;
  PAYER_NAME: string;
  PROCEDURE_LATERALITY: string;
  ANESTHESIA_TYPE: string;
  DIAGNOSIS_LIST: string;
  PRIMARY_PROCEDURES: string;
  SECONDARY_PROCEDURES: string;
  MODIFIER_MAP: string;
}

export type Laterality = 'left' | 'right' | 'bilateral';

export const LATERALITY_MODIFIER_MAP: Record<Laterality, string> = {
  left: 'LT',
  right: 'RT',
  bilateral: '50',
};

export const LATERALITY_LABELS: Record<Laterality, string> = {
  left: 'Left',
  right: 'Right',
  bilateral: 'Bilateral',
};

export interface Assistant {
  id: string;
  assistant_name: string;
  credentials: string;
  default_enabled: boolean;
  specialty_scope: string | null;
  active_status: boolean;
  created_at: string;
  updated_at: string;
}
